/* istanbul ignore file */
import React from 'react';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { AudienceCampaignCreationWizard } from '@bingads-webui-campaign-legacy/audience-campaign/loader';
import PageContext from '@bingads-webui-static-legacy/page-context';
import { getEntityCreationStyle } from '../styles';
import { InjectWrapperWithHoC, withCreationHeader } from '../helper';
import VerticalLayout from '../template/steps-template.pug';
import HeaderTemplate from '../template/header-template.pug';

function CampaignCreationAudienceVideo(props) {
  const {
    serverContext: {
      CurrentAccount: {
        CurrencyCode,
      },
      CurrentAccountInActive,
      Permissions: {
        IsReadOnlyUser,
        IsImpressionTrackingUrlsEnabled,
      },
    },
    perfMarker,
    i18n,
  } = props;
  return (
    <InjectWrapperWithHoC
      {...props}
      InjectViewFactory={() => Promise.resolve(AudienceCampaignCreationWizard)}
      InjectViewOption={{
        viewContext: {
          accountCurrencyCode: CurrencyCode,
          isReadOnlyUser: IsReadOnlyUser,
          CurrentAccountInActive,
        },
        perfMarker,
        layout: VerticalLayout,
        headerTemplate: HeaderTemplate,
        isForVNext: true,
        isImpressionTrackingUrlsEnabled: IsImpressionTrackingUrlsEnabled,
        isVideo: true,
        newI18n: i18n,
        deps: {
          pageContext: PageContext,
        },
      }}
      styleScopeName="CampaignCreationAudience"
    />);
}

CampaignCreationAudienceVideo.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({
      CurrencyCode: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }),
};

CampaignCreationAudienceVideo.defaultProps = {
  i18n: {
    getString: text => text,
  },
};

export const StyledCampaignCreationAudienceVideo =
  withDefaultStyles(withCreationHeader(CampaignCreationAudienceVideo), getEntityCreationStyle);
